import { Const } from '../lib/const.cls'

import * as RxFactory from '../../../../../store/api/rx-factory'

import { GET_TOKEN, SET_STATE, GET_USER } from '../../../../../types'

// vue-webapp server address @see config/prod.env.js, dev.env.js, test.env.js 
// export const TRADER_ROOT = process.env.LOCAL_TRADER_SERVER_FULL_ADDRESS
export const TRADER_ROOT = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS




export const EP_TRADER_INFORMATION 		= '/api/trader/get/information'

export const EP_TRADER_LOGOUT 			= "/api/trader/logout"

export const  EP_UPDATE_USER_INFO 		= "/update/user/info"

export const  EP_GET_USER_INFO 			= "/fetch/user/info"

export const EP_GET_PAYIN_LINK 			= '/service/payment'

export const EP_GET_PAYOUT_LINK 		= '/api/payout'

export const EP_GET_QR_CODE 			= '/api/enable/two/factor'

export const EP_VERIFY_2_token_ONE_TIME = '/api/onetime/verif/two/factor/token'

export const EP_VERIFY_2_token 			= '/api/verif/two/factor/token'

export const EP_VERIFY_OTP 				= '/api/verify/OTP'

export const EP_TRADER_BUY_SELL 		= '/trade/buy/sell/pending'

export const EP_TRADER_BUY_SELL_MARKET 	= '/trade/buy/sell/market'

export const EP_TRADER_BUY_SELL_BO 		= '/trade/buy/sell/bo'

export const EP_TRADER_BUY_SELL_MODIFY 	= '/trade/buy/sell/market/modify'

export const EP_DELETE_ORDER 			= '/order/delete'

export const EP_CLOSE_TRADE 			= '/trade/close'		

export const EP_GET_ORDER_HISTORY 		= '/get/order/history'

export const EP_GET_TRADING_ACCOUNT 	= '/get/trading/id/list'

export const EP_GET_DASHBOARD_DATA 		= '/get/data'

export const EP_GET_DEPOSIT_DATA 		= '/get/deposit/list'

export const EP_GET_WITHDRAWAL_DATA 	= '/get/withdrawal/list'

export const EP_GET_MARGIN_INFO 		= '/get/margin/market/status'

export const EP_COVER_ORDER_INFO 		= '/get/cover/order/percentage'

export const EP_COVER_ORDER_EXIT 		= '/get/cover/order/exit'


export const EP_BO_ORDER_EXIT 			= '/get/bo/order/exit'

export const EP_GET_USER_LOGS  			= '/get/user/log/'

export const EP_GET_EXCHANGE_MSG  		= '/exchange/msg'

export const EP_GENRATE_OTP 			= '/api/genrate/otp'

export const EP_PUT_WITHDRAW_REQUEST 	= '/get/withdrawal/request'

export const EP_GET_BONUS_DATA   		= '/get/bonus/list'

export const EP_GET_BANK_DETAILS   		= '/get/bank/detail'

export const EP_GET_CARD_LIST   		= '/get/card/list'

export const EP_GET_TICKET_LIST   		= '/get/ticket/list'

export const EP_SAVE_TICKET   			= '/save/ticket/'

export const EP_TICKET_VIEW				= '/get/ticket/view'

export const EP_CREATE_LIVE_ACCOUNT   	= '/create/account/live'

export const EP_UDPATE_LIVE_ACCOUNT   	= '/update/account/live'

export const EP_CREATE_DEMO_ACCOUNT   	= '/create/account/demo'

export const EP_UPDATE_PEROSNAL_INFO   	= '/update/user/personal/info'

export const EP_GET_CALLBACK   			= '/get/callback/address'

export const EP_UPLOADCREDITCARDINFO 	= '/add/card' 

export const EP_INDIVIDUALUPLOAD 		= '/individual/account'

export const EP_CORPORATEUPLOAD 		= '/corporate/account'

export const EP_DOCUMENTLIST 			= '/get/document/list'

export const EP_DOCUMENTUPLOAD			= '/upload/document'

export const EP_SCRIP_INFO				= '/get/scrip/info'

export const EP_SAVE_BANK_DETAIL 		= '/add/bank/detail'

export const EP_GET_DEPOSIT_ADDRESS 	= '/get/deposit/address'

export const EP_GET_ALL_ISINS 			= '/api/ws-price-feed/all'

export const OPTION_CALCULATOR 			= '/option/calculator' 

export const CHART_UPTDATE_DATA 		= '/api/ws-chart-engine/intraday/data'

import axios from 'axios'
const CancelToken = axios.CancelToken;
let cancel;



let get_information_interval = '';

let errors = {}

let position_type = "DAY"
/*
Genral errors!

*/
errors[1] = ""
errors[2] = "Something went wrong. Please try again!"
errors[3] = "Invalid data"
errors[4] = "Something went wrong. We are onto it!"
errors[5] = ""
errors[6] =  "Connection Lost!"
errors[7] =  ""

/*
Error codes (for commands open_order, close_order, and change_sl_tp)

*/

errors['5000'] = " Market closed "
errors['5001'] = " Off quotes! "
errors['5002'] = " Invalid volume! "
errors['5003'] = " Invalid sl/tp "


/*
Trading errors!

*/
errors['129'] = " Invalid sl/tp "
errors['130'] = " Invalid stops level "
errors['131'] = " Invalid lot size"
errors['132'] = " Market closed "
errors['133'] = " Trade disabled "
errors['134'] = " No sufficient money to execute the order "
errors['135'] = " price changed "

const Swal = require('sweetalert2')

let tempTransactionid = ""

export const actions = {

  	// gets invoked by the web socket's formatter function
  	// to update instruments in the store
	
  	

  	[Const.RUN_USER_LOGOUT] ({commit, state, getters}, data) {
  		

  		let router = data.router
  		let parameter = data.parameter

  		delete data.parameter
  		delete data.router

  		parameter.$parent.$parent.loading = 1

		RxFactory.post(TRADER_ROOT + EP_TRADER_LOGOUT, data, {
	      'Authorization': 'Bearer ' + getters[GET_TOKEN]
	    })
	      .map(response => response.data)
	      .subscribe(data => {

	      	parameter.$parent.$parent.loading = 0
	      	
	      	_handleLogout(data, commit, {router: router, forward:true})
					 
	      },
	      (e, d, s) => {

	      	parameter.$parent.$parent.loading = 0

			_handleLogout(data, commit, {router: router, forward:true})
	        // _handleLogout(e, commit, {router: router, forward:true})
	      }
	    )
	},

	

	[Const.RUN_GET_DEPOSIT_ADDRESS]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				commit(Const.SET_LOADER_STATUS, 1)
				RxFactory.post(TRADER_ROOT + EP_GET_DEPOSIT_ADDRESS, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							console.log("data", data)
							commit(Const.SET_DEPOSIT_ADDRESS, data.data)
							commit(Const.SET_LOADER_STATUS, 0)
						}
						else{
							Swal("Error!", "Something went wrong. Please try again!", "error")
						}
					}
					commit(Const.SET_LOADER_STATUS, 0)
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',
  					confirmButtonText: 'logout'})
					commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				})
  				
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			commit(Const.SET_LOADER_STATUS, 0)
			_handleErrorResponse(ex, commit)
		}
  	},

	[Const.RUN_GET_TRADERING_ID]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				
				RxFactory.post(TRADER_ROOT + EP_GET_TRADING_ACCOUNT, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {

							/*****************Output of Convert array **********************/
							// here we are converting accounts acc to 
							// Live: {"MT4 OR otheres":[]}, {"ZULU": ""}}
							/*****************Output of Convert array end********************/
							let accountwiseid= {}
							let tradingids = data.data
							for (var i = tradingids.length - 1; i >= 0; i--) {

								if(!(tradingids[i].demo_live in accountwiseid)){
					    			accountwiseid[tradingids[i].demo_live]={}
					    		}

					    		if(!(tradingids[i].platform in accountwiseid[tradingids[i].demo_live])){
					    			accountwiseid[tradingids[i].demo_live][tradingids[i].platform] = []
					    		}
								
								accountwiseid[tradingids[i].demo_live][tradingids[i].platform].push(tradingids[i])

					    	}
							commit(Const.SET_TRADING_ACCOUNT, accountwiseid)
						}
					}
				},
				e => {

					// Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',
  			// 		confirmButtonText: 'logout'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_DEPOSIT_HISTORY]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this


				RxFactory.post(TRADER_ROOT + EP_GET_DEPOSIT_DATA, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							commit(Const.SET_DEPOSIT_HISTORY, data.data)
						}
					}
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	

  	[Const.RUN_OPTION_CALCULATOR]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const parameter = data.parameter
				delete data.parameter

				const self = this
				RxFactory.post(TRADER_ROOT + OPTION_CALCULATOR, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							parameter.opt_Delta = data.data.opt_Delta
				            parameter.opt_Gamma=data.data.opt_Gamma
				            parameter.opt_Rho=data.data.opt_Rho
				            parameter.opt_Theta=data.data.opt_Theta
				            parameter.opt_Vega=data.data.opt_Vega
				           	parameter.opt_theoriticalprice=data.data.opt_theoriticalprice
						}
					}
				},
				e => {

					// Swal({title: "Slow Internet!"+ get_information_interval, text: 'you\'re too slow!', type: 'error',
  			// 		confirmButtonText: 'logout'})
  					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_SCRIP_INFO]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				commit(Const.SET_SCRIP_INFO, [])
				RxFactory.post(TRADER_ROOT + EP_SCRIP_INFO, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							commit(Const.SET_SCRIP_INFO, data.data)
						}
					}
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	

  	[Const.RUN_GET_MARGIN_INFO]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				
				RxFactory.post(TRADER_ROOT + EP_GET_MARGIN_INFO, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							
							if(localStorage.getItem('MY_MARGINS') != '' && localStorage.getItem('MY_MARGINS') !== null){
								data.data['MARGIN_INFO'].UnbookedPNL = JSON.parse(localStorage.getItem('MY_MARGINS')).MARGIN_INFO.UnbookedPNL;						
							}
							commit(Const.SET_MARGIN_INFO,  data.data['MARGIN_INFO'])

							commit(Const.SET_MARKET_STATUS,  data.data['MARKET_STATUS'])

							localStorage.setItem('MY_MARGINS', JSON.stringify(data.data));

							$('[data-toggle="tooltip"]').tooltip();
            				$('.tooltip').tooltip();
						}
					}
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_CHART_DATA]({commit, state, getters, dispatch}, data){
  		
  		const self = this

  		// identifier: 1130
		// startdate: 1544596920000
		// interval: minute
		// period: 1
		// exh: CDS
		// extended: 0
		// ciqrandom: 1544596940885

		RxFactory.get(TRADER_ROOT + CHART_UPTDATE_DATA, data, 
		{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
		.map(response => response.data)
		.subscribe(data => {
			if ('info' in data) {
				if (data.info === 'OK') {
					console.log("data over here", data)
				}
			}
		},
		e => {

		})
  	},
  	

  	[Const.RUN_GENRATE_OTP]({commit, state, getters, dispatch}, data){
  		try {
				const self = this
				const parameter = data.params
				delete data.params

				if(parseFloat(data.amount) > 5){
					Swal("Error!", "Minimum withdrawal amount is $5", "error");
				}
				else if(parseFloat(data.free_margin) <= parseFloat(data.amount)){
					Swal("Error!", "You can not withdraw more than your free margin", "error");
				}else{

					RxFactory.post(TRADER_ROOT + EP_GENRATE_OTP, data, 
					{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
					.map(response => response.data)
					.subscribe(data => {
						if ('info' in data) {
							if (data.info === 'OK') {
								// console.log("genrate OTP", data.data.transcationId)
								tempTransactionid = data.data.transcationId
								parameter.show_otp = 1
								// Swal("Success!", "Successfully Requested!", "success");							
							}
						}
					},
					e => {

						Swal("Error!", "Something went wrong. Please try again", "error");
						
						_handleErrorResponse(e, commit)
					})
	  			
	  				_cleanUp(commit, data, 200, 'a')
				}
				
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
  	
  	
  	[Const.RUN_GET_USER_INFO]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this

				RxFactory.post(TRADER_ROOT + EP_GET_USER_INFO, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							commit(Const.SET_USER_EXTRA_INFO, data.data)
						}
					}
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
  	

	
	[Const.RUN_UPDATE_PROFILE]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				
				RxFactory.post(TRADER_ROOT + EP_UPDATE_PEROSNAL_INFO, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {

					if ('info' in data) {
						if (data.info === 'OK') {

							// commit(Const.SET_TICKET_LIST, data.data)
							Swal("Success!", "Successfully Updated!", "success");
						}
					}
				},
				e => {

					Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',
  					confirmButtonText: 'logout'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_CALLBACK_ADDRESS]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				
				RxFactory.post(TRADER_ROOT + EP_GET_CALLBACK, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {

					if ('info' in data) {
						if (data.info === 'OK') {

							// commit(Const.SET_TICKET_LIST, data.data)
							Swal("Success!", "Successfully Updated!", "success");
						}
					}
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_PAYIN_LINK]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				
				RxFactory.post(TRADER_ROOT + EP_GET_PAYIN_LINK, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {

					if ('info' in data) {
						if (data.info === 'OK') {
							// window.open(data.data.result)
							window.location.href = data.data.result
							// Swal("Success!", "Successfully Updated!", "success");
						}
					}
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_PAY_OUT]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				const param = data.parameter
				delete data.parameter
				
				param.$notify({
	              group: 'foo',
	              title: 'Success!',
	              text: "Request genrated Successfully!",
	              type: 'success',
	            });

				RxFactory.post(TRADER_ROOT + EP_GET_PAYOUT_LINK, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {

					if ('info' in data) {
						if (data.info === 'OK') {
							// window.location = data.data.result
							// Swal("Success!", "Successfully Updated!", "success");
							// parameter.$notify({
				   //            group: 'foo',
				   //            title: 'Success!',
				   //            text: "Request genrated Successfully!",
				   //            type: 'success',
				   //          });
						}
					}
				},
				e => {

					Swal({title: "Slow Network Connection", text: 'Check your internet connection. If the problem continues, try reloading the page', type: 'error',confirmButtonText: 'Ok'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},


  	
  	
  	

  	[Const.RUN_GET_TRADERING_INFO]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				if(data === undefined){
					data = {}
				}
				data.page = 'DASHBOARD'
				data.platform = "TRADER"
				const self = this


				
				// RxFactory
				RxFactory.post(TRADER_ROOT + "/get/data", data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN]},
				)
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						
						if (data.info.toLowerCase() == 'ok') {		
							const respdata = data.data;					
							const closed_order_array = respdata['CLOSED_ORDER']
						 	
						 	let oldOpenPosition = getters[Const.GET_OPEN_POSITION]
							let newOpenPosition = respdata['OPEN_POSITION']

							if(JSON.stringify(oldOpenPosition) !== JSON.stringify(newOpenPosition)){
								
								let positionResp = newOpenPosition['DAY'][0]['Emsg']
								let positionRespNET = newOpenPosition['NET'][0]['Emsg']
								if(positionResp === undefined && positionRespNET === undefined){
									commit(Const.SET_OPEN_POSITION, respdata['OPEN_POSITION'])	
								}

								else if(positionResp !== undefined && positionRespNET === undefined){
									newOpenPosition['DAY'] = []
									commit(Const.SET_OPEN_POSITION, newOpenPosition)	
								}
								else if(positionResp === undefined && positionRespNET !== undefined){
									newOpenPosition['NET'] = []
									commit(Const.SET_OPEN_POSITION, newOpenPosition)	
								}
								
							}
							
							if(JSON.stringify(oldOpenHolding) !== JSON.stringify(newOpenHolding)){
								if(newOpenHolding[0] === undefined){
									commit(Const.SET_OPEN_HOLDINGS, respdata['OPEN_HOLDING'])
								}

							}

							
							let oldOpenOrder = getters[Const.GET_OPEN_ORDER]
							let newOpenOrder = respdata['OPEN_ORDERS']

							if(JSON.stringify(oldOpenOrder) !== JSON.stringify(newOpenOrder)){
								let newOpenOrderResp = newOpenOrder[0]['Emsg']
								if(newOpenOrderResp === undefined){
									commit(Const.SET_OPEN_ORDER, respdata['OPEN_ORDERS'])
								}
															
							}

							let oldMarginInfo = getters[Const.GET_MARGIN_INFO]
							let newMarginInfo = respdata['MARGIN_INFO']

							if(JSON.stringify(oldMarginInfo) !== JSON.stringify(newMarginInfo)){
								commit(Const.SET_MARGIN_INFO, 	newMarginInfo['MARGIN_INFO'])

							}
							localStorage.setItem('MY_MARGINS', JSON.stringify(respdata['MARGIN_INFO']));
							localStorage.setItem('OPEN_HOLDING', JSON.stringify(respdata['OPEN_HOLDING']));
							localStorage.setItem('OPEN_TRADES', JSON.stringify(respdata['TRADE_HISTROY']));	
							commit(Const.SET_MARKET_STATUS,  data.data['MARGIN_INFO']['MARKET_STATUS']) 
						}
					}
					
				},
				e => {

					// Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',
  					// confirmButtonText: 'logout'})
  					// commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				})

  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_SQUARE_OFF]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				const parameter = data.params
				delete data.params
				RxFactory.post(TRADER_ROOT + "/square/off/position", data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if (data.info === 'OK') {
						if ('stat' in data.data){
							if(data.data.stat == 'Ok'){
								// parameter.$parent.show_buy = 0
								parameter.$notify({
					              group: 'foo',
					              title: 'Success!',
					              text: "Squared Off Successfully!",
					              type: 'success',
					            });
							}
							else{
								parameter.$notify({
					              group: 'foo',
					              title: 'error!',
					              text: data.data.Emsg,
					              type: 'error',
					            });
								// Swal({title: "Error! ", text: "Something went wrong please check!", type: 'error', confirmButtonText: 'Ok'})
							}
						}
					}
					else{
							Swal({title: "Error! ", text: data.msg, type: 'error',
		  					confirmButtonText: 'Ok'})
					}
				})
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_PARTIAL_POSITION]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				const parameter = data.params
				delete data.params

				parameter.$parent.$parent.loading = 1
				parameter.close_popup()
				
				RxFactory.post(TRADER_ROOT + "/partial/position/conversion", data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
				
					parameter.$parent.$parent.loading = 0
					if (data.info === 'OK') {
						if ('stat' in data.data){
							if(data.data.stat == 'Ok'){
								// parameter.$parent.show_buy = 0
								parameter.$notify({
					              group: 'foo',
					              title: 'Sucess!',
					              text: "Partial Position coverted successfully!",
					              type: 'success',
					            });

					            parameter.close_popup()

					            dispatch(Const.RUN_GET_TRADERING_INFO)
							}
							else{
								parameter.$notify({
					              group: 'foo',
					              title: 'error!',
					              text: data.data.Emsg,
					              type: 'error',
					            });
								// Swal({title: "Error! ", text: data.data.Emsg, type: 'error', confirmButtonText: 'Ok'})
							}
						}
					}
					else{
							Swal({title: "Error! ", text: data.msg, type: 'error',
		  					confirmButtonText: 'Ok'})
					}
				})
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
  

  	[Const.RUN_GET_HISTORY]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				commit(Const.SET_LOADER_STATUS, 1)
				RxFactory.post(TRADER_ROOT + EP_GET_DASHBOARD_DATA, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					commit(Const.SET_LOADER_STATUS, 0)
					if ('info' in data) {
						if (data.info === 'OK') {
							const respdata = data.data;
							
							commit(Const.SET_CLOSED_ORDER, respdata['CLOSED_ORDER'])
						}
					}
				},
				e => {

					// Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',
  					// confirmButtonText: 'logout'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_OPEN_ORDER]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				RxFactory.post(TRADER_ROOT + EP_GET_DASHBOARD_DATA, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							commit(Const.SET_OPEN_POSITION, data.data.OPEN_ORDER)
						}
					}
				},
				e => {

					// Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',
  					// confirmButtonText: 'logout'})

					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
  	
	[Const.RUN_GET_DASHBOARD_DATA]({commit, state, getters, dispatch}, data){
  		try {
				// data['session'] = "AeKdT5AJ"
				const self = this
				
				// commit(Const.SET_LOADER_STATUS, 1)
				
				commit(Const.SET_GRAPH_DATA, [])
				
				commit(Const.SET_OPEN_POSITION, [])
							
				commit(Const.SET_MARGIN_INFO, [])

				commit(Const.SET_CLOSED_ORDER, 	[])

				RxFactory.post(TRADER_ROOT + EP_GET_DASHBOARD_DATA, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					
					commit(Const.SET_LOADER_STATUS, 0)

					if ('info' in data) {
						if (data.info === 'OK') {
							const respdata = data.data;
							
							commit(Const.SET_OPEN_POSITION, respdata['OPEN_ORDER'])
							
							commit(Const.SET_MARGIN_INFO, 	respdata['MARGIN_INFO'])
						 	
						 	commit(Const.SET_CLOSED_ORDER, respdata['CLOSED_ORDER'])

						 	const closed_order_array = respdata['CLOSED_ORDER']

						 	let date_wise_close_pnl = closed_order_array[closed_order_array.length-1]

						 	let sorted_array = Object.entries(date_wise_close_pnl['close_pnl_datewise']).sort()

						 	for (var i = 0; i < sorted_array.length; i++) {
						 		sorted_array[i][0] = parseInt(sorted_array[i][0])
						 	}
						 	commit(Const.SET_GRAPH_DATA, sorted_array)
						 	
						 	

						 	// let graphData = []
						 	// let dummy = []
						 	// for (var i = 0; i < respdata['CLOSED_ORDER'].length; i++) {
					   //        let dateWiseDate = []

					   //        dateWiseDate.push(parseInt(respdata['CLOSED_ORDER'][i]['close_time'])*1000)
					   //        dateWiseDate.push(parseFloat(respdata['CLOSED_ORDER'][i]['profit']))
					          
					   //        graphData.push(dateWiseDate)
					          
					   //        if(i == respdata['CLOSED_ORDER'].length-1) {
					   //        	graphData.sort(function(a, b)
								// {
								//     return a[0] - b[0];
								// });
					   //        	commit(Const.SET_GRAPH_DATA, graphData)
					   //        }
					   //      }
					        
						}
						
					}
					
				},
				e => {

					// Swal({title: "Oops! Session expired"+ get_information_interval, text: 'you\'re too slow!', type: 'error',
  					// confirmButtonText: 'logout'})
  					commit(Const.SET_LOADER_STATUS, 0)
					_handleErrorResponse(e, commit)
				})
  				
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
	
	[Const.RUN_BUY_SELL_TRADE]({commit, state, getters, dispatch}, data){
  		try {
				
				// data['session'] = "AeKdT5AJ"
				const user_input = data.parameter
				delete data.parameter

				RxFactory.post(TRADER_ROOT + EP_TRADER_BUY_SELL, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data){
								if(data.data.stat == 'Ok'){
									user_input.$parent.show_buy = 0
									user_input.$notify({
						              group: 'foo',
						              title: 'Important message',
						              text: 'Hello user! This is a notification!',
						              type: 'success',
						            });
									// Swal({title: "Success! ", text: "Trade Successfully!", type: 'success',
			  				// 		confirmButtonText: 'Ok'})
								}
								else{
									Swal({title: "Error! ", text: data.msg, type: 'error', confirmButtonText: 'Ok'})
								}
							}
							user_input.show_buy = -1;
          					user_input.show_sell = -1;
						}	
						else{

								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_MODIFY_ORDER]({commit, state, getters, dispatch}, data){
  		try {
				
				// data['session'] = "AeKdT5AJ"
				const parameter = data.parameter
				delete data.parameter

				RxFactory.post(TRADER_ROOT + EP_TRADER_BUY_SELL_MODIFY, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data){
								if(data.data.stat == 'Ok'){
									parameter.$parent.show_edit = -1
									// Swal({title: "Success! ", text: "Modified Successfully!", type: 'success',
			  				// 		confirmButtonText: 'Ok'})
			  						parameter.$notify({
						              group: 'foo',
						              title: 'Success!',
						              text: "Modified Successfully!",
						              type: 'success',
						            });
								}
								else{
									parameter.$notify({
						              group: 'foo',
						              title: 'Error!',
						              text: data.data.Emsg,
						              type: 'error',
						            });
									// Swal({title: "Error! ", text: data.msg, type: 'error', confirmButtonText: 'Ok'})
								}
							}
							
						}	
						else{

								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_ORDER_REQUIRED_DETAIL]({commit, state, getters, dispatch}, data){
  		try {
				
				// data['session'] = "AeKdT5AJ"
				const parameter = data.parameter
				delete data.parameter

				RxFactory.post(TRADER_ROOT + EP_COVER_ORDER_INFO, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data){
								if(data.data.stat == 'Ok'){
									parameter.price_range = data.data.TriggerPriceRange
									parameter.prec_max = data.data.Coverprc
									
								}
								else{
									// Swal({title: "Error! ", text: data.msg, type: 'error', confirmButtonText: 'Ok'})
								}
							}
							
						}	
						else{

								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_EXIT_COVER_ORDER]({commit, state, getters, dispatch}, data){
  		try {
  				const parameter = data.params
  				delete data.params
				RxFactory.post(TRADER_ROOT + EP_COVER_ORDER_EXIT, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data){
								if(data.data.stat == 'Ok'){
									parameter.$notify({
						              group: 'foo',
						              title: 'Success!',
						              text: 'Exit cover order Successfully!',
						              type: 'success',
						            });
								}
								else{
									parameter.$notify({
						              group: 'foo',
						              title: 'Success!',
						              text: data.data.Emsg,
						              type: 'success',
						            });
									// Swal({title: "Error! ", text: data.data.Emsg, type: 'error', confirmButtonText: 'Ok'})
								}
							}
							
						}	
						else{

								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_EXIT_BRACKET_ORDER]({commit, state, getters, dispatch}, data){
  		try {
  				const parameter = data.params
  				delete data.params
				RxFactory.post(TRADER_ROOT + EP_BO_ORDER_EXIT, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data){
								if(data.data.stat == 'Ok'){
									parameter.$notify({
						              group: 'foo',
						              title: 'Success!',
						              text: 'Exit BO Successfully!',
						              type: 'success',
						            });
								}
								else{
									parameter.$notify({
						              group: 'foo',
						              title: 'Error!',
						              text: data.data.Emsg,
						              type: 'error',
						            });
									// Swal({title: "Error! ", text: data.data.Emsg, type: 'error', confirmButtonText: 'Ok'})
								}
							}
							
						}	
						else{

								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_USER_LOGS]({commit, state, getters, dispatch}, data){
  		try {
  				
				RxFactory.post(TRADER_ROOT + EP_GET_USER_LOGS, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK' ) {
							if ('stat' in data.data){

								commit(Const.SET_USER_LOGS, data.data.Usermsg.split("/n"))
							}else{
								commit(Const.SET_USER_LOGS, [])
							}
							
						}	
						
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_GET_EXCHANGE_MSG]({commit, state, getters, dispatch}, data){
  		try {
  				
				RxFactory.post(TRADER_ROOT + EP_GET_EXCHANGE_MSG, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data && data.data.Exchmsg !== 'No Data'){

								commit(Const.SET_EXCHANGE_MSG, data.data.Exchmsg.split("/n"))
							}else{
								commit(Const.SET_EXCHANGE_MSG, [])
							}
						}	
						else{
							commit(Const.SET_EXCHANGE_MSG, [])
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},  	

  	[Const.RUN_GET_ORDER_HISTORY]({commit, state, getters, dispatch}, data){
  		try {
  				// const parameter = data.params
  				// delete data.params
				RxFactory.post(TRADER_ROOT + EP_GET_ORDER_HISTORY, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							
							commit(Const.SET_ORDER_HISTORY, data.data)
							
						}	
						else{

								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},


  	


	[Const.RUN_BUY_SELL_MARKET]({commit, state, getters, dispatch}, data){
  		try {
				
				// data['session'] = "AeKdT5AJ"
				const parameter = data.parameter
				delete data.parameter

				RxFactory.post(TRADER_ROOT + EP_TRADER_BUY_SELL_MARKET, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data){
								if(data.data.stat == 'Ok'){
									parameter.$parent.show_buy = 0.
									
									parameter.$notify({
						              group: 'foo',
						              title: 'Success',
						              text: 'Trade Successfully!',
						              type: 'success',
						            });
									// Swal({title: "Sucess! ", text: "Trade Successfully!", type: 'success',
			  				// 		confirmButtonText: 'Ok'})
								}
								else{
									parameter.$notify({
						              group: 'foo',
						              title: 'Error!',
						              text: data.data.Emsg,
						              type: 'error',
						            });
									// Swal({title: "Error! ", text: data.msg, type: 'error', confirmButtonText: 'Ok'})
								}
							}
						}
						else{
								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_PLACE_BRACKET_ORDER]({commit, state, getters, dispatch}, data){
  		try {
				
				// data['session'] = "AeKdT5AJ"
				const parameter = data.parameter
				delete data.parameter

				RxFactory.post(TRADER_ROOT + EP_TRADER_BUY_SELL_BO, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							if ('stat' in data.data){
								if(data.data.stat == 'Ok'){
									parameter.$parent.show_buy = 0
									// Swal({title: "Sucess! ", text: "Trade Successfully!", type: 'sucess',
			  						// confirmButtonText: 'Ok'})
			  						parameter.$notify({
						              group: 'foo',
						              title: 'Success',
						              text: 'BO Trade Successfully!',
						              type: 'success',
						            });
								}
								else{
									parameter.$notify({
						              group: 'foo',
						              title: 'Error',
						              text: data.data.Emsg,
						              type: 'error',
						            });
									// Swal({title: "Error! ", text: data.msg, type: 'error', confirmButtonText: 'Ok'})
								}
							}
						}
						else{
								Swal({title: "Error! ", text: data.msg, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	

  	[Const.RUN_DELETE_ORDER]({commit, state, getters, dispatch}, data){
  		try {
				
  				const params = data.parameter
  				delete data.parameter
				// data['session'] = "AeKdT5AJ"
				RxFactory.post(TRADER_ROOT + EP_DELETE_ORDER, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					
					if ('info' in data) {
						if (data.info === 'OK') {
							// Swal({title: "Success! ", text: "Successfully Canceled!", type: 'success',
			  		// 			confirmButtonText: 'Ok'})
			  				params.$notify({
				              group: 'foo',
				              title: 'Success!',
				              text: 'Successfully Canceled!',
				              type: 'success',
				            });
						}
						else{
							params.$notify({
				              group: 'foo',
				              title: 'Error!',
				              text: "Error",
				              type: "error",
				            });
								// Swal({title: "Error! ", text: data.data.error.$.message, type: 'error',
			  			// 		confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					// alert("Ohhhhhh inside exception")
					console.log("In [e]", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_CLOSE_TRADE]({commit, state, getters, dispatch}, data){
  		try {
				
				// data['session'] = "AeKdT5AJ"
				const requested_value = data
				const parameter = data.parameter
				delete data.parameter

				RxFactory.post(TRADER_ROOT + EP_CLOSE_TRADE, data, 
				{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							$(".show_all").show();
						}
						else{

								parameter.closed_trade_id.splice( parameter.closed_trade_id.indexOf(requested_value.trade_id), 1)
								Swal({title: "Error! ", text: data.data.error.$.message, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
					}
				},
				e => {
					console.log("In e", e)
					_handleErrorResponse(e, commit)
				})
  			
  				_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

	[Const.RUN_TWO_FACTOR_AUTH]({commit, state, getters, dispatch}, data){
  		try {
			
			RxFactory.post(TRADER_ROOT + EP_GET_QR_CODE, data, 
			{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
			.map(response => response.data)
			.subscribe(data => {
				if ('info' in data) {
					if (data.info === 'OK') {
						commit(Const.SET_QR_CODE, data.data.qrcode)							
					}
					else{

								Swal({title: "Error! ", text: data.data.error.$.message, type: 'error',
			  					confirmButtonText: 'Ok'})
						}
				}
			},
			e => {
				console.log("In e", e)
				_handleErrorResponse(e, commit)
			})
			_cleanUp(commit, data, 200, 'a')
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_VERIFICATION_AUTH_TOKEN_ONE_TIME]({commit, state, getters, dispatch}, data){
  		try {
			
			RxFactory.post(TRADER_ROOT + EP_VERIFY_2_token_ONE_TIME, data, 
			{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
			.map(response => response.data)
			.subscribe(data => {
				if ('info' in data) {
					if (data.info === 'OK') {
						data = getters['GET_USER']

						data.user.profile.gAuthenticatorEnabled = 1

						commit(Const.SET_TRADER_BASIC_INFO, data)					

						window.sessionStorage.setItem('user', btoa(JSON.stringify(data)))

					}
				}
			},
			e => {
				console.log("In e", e)
				_handleErrorResponse(e, commit)
			})
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

  	[Const.RUN_VERIFICATION_AUTH_TOKEN]({commit, state, getters, dispatch}, data){
  		try {

  			const routerTmp = data.router
			delete data.router
			
			let req_data= {}
			req_data['token'] = data.google_token
			RxFactory.post(TRADER_ROOT + EP_VERIFY_2_token, data, 
			{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
			.map(response => response.data)
			.subscribe(data => {
				if ('info' in data) {
					if (data.info === 'OK') {
						routerTmp.replace("/trader")				
					}
				}
			})

			// e => {
			// 	console.log("In e", e)
			// 	_handleErrorResponse(e, commit)
			// })
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},
  	
  	[Const.RUN_VERIFY_OTP]({commit, state, getters, dispatch}, data){
  		try {

  			const routerTmp = data.router
			delete data.router
			let req_data= {}
			req_data['token'] = data.google_token
			console.log(data)
			RxFactory.post(TRADER_ROOT + EP_VERIFY_OTP, data, 
			{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
			.map(response => response.data)
			.subscribe(data => {
				if ('info' in data) {
					if (data.info === 'OK') {
						let userData = getters[GET_USER]

						userData.user.profile.account_verified = 1
						
						commit(SET_STATE, {user:userData})
						
						window.sessionStorage.setItem('user', btoa(JSON.stringify(userData)))
							
						// routerTmp.replace("/dashboard")				
					}
					else{
						_cleanUp(commit, data, 200, 'a')
					}
				}
			})

			// e => {
			// 	console.log("In e", e)
			// 	_handleErrorResponse(e, commit)
			// })
  			
  			
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
  	},

	[Const.RUN_UPDATE_USER_INFO]({commit, state, getters, dispatch}, data){
		try {

			const selected_theme_info= data.color_scheme
			RxFactory.post(TRADER_ROOT + EP_UPDATE_USER_INFO, data, 
		{ 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
		.map(response => response.data)
		.subscribe(data => {
			if ('info' in data) {
				let data = {}
				// try to get user from session storage
			    let user = window.sessionStorage.getItem('user_info')



			    if (user) {
						data = JSON.parse(atob(user)) // user is additionally base64 encrypted

			      
			    } else {
			      data = getters[Const.GET_TRADER_BASIC_INFO]
				}
				
				if(data!=undefined){

					if(selected_theme_info!=undefined) data.user.profile.color_scheme = selected_theme_info

					commit(Const.SET_TRADER_BASIC_INFO, data)

					window.sessionStorage.setItem('user_info', btoa(JSON.stringify(data)))

				}
			}
		})		
		_cleanUp(commit, data, 200, 'a')	
			
	} catch (ex) {
		console.log("In e", ex)
		
	}
	},


}

function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  	// toggle loader 'a', 'b', 'c'
	// commit(SET_TOGGLE_LOADER, loaderArr)
	// commit(Const.SET_LOADER_STATUS, 0)
 	commit("SET_INFO", msg)
}

function _handleErrorResponse (e, commit) {
  let response = {info: 'NOK', msg: 'Service not available'}
  if (typeof e.response === 'undefined') {
    try {
      const statusCheck = e.toString().toLowerCase()
      if (statusCheck.indexOf('network') > -1) {
        response = {info: 'NOK', msg: 'Network Error'}
      }
      console.log("statusCheck", statusCheck)
    } catch (e) {}
  } else {
  	 	console.log("statusCheck", e.response.status)
    	response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if(typeof e.response !== 'undefined'){
		if(e.response.status == 401){
 			let data = {}
			let options = {}
			options.forward = true
	 		_handleLogout(data, commit, options)
	 	}
	}
}

function _handleLogout (data, commit, options) {
	console.log('_handleLogout args', data, options)
	let user = {}
	const state = []
	// set state (user, token)
	commit(Const.SET_TRADER_BASIC_INFO, state)

	// save state to local storage (user)
	window.sessionStorage.setItem('user', "")

	localStorage.setItem('user', "")

	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	// route back to blockmaze portal
	// ---------------TBC-------------
	if (options.forward === true) {
		window.location.replace("/login")
		// options.router.replace({ path : "/" })
	}
}



// WEBPACK FOOTER //
// ./src/plugins/scalpert/provider/candle-history/store-addons/actions.js